export const dashToPascalCase = (str) => str
    .toLowerCase()
    .split('-')
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join('');
export const kebabCase = (str) => {
    return str
        .replace(/([a-z][A-Z])/g, function (match) {
        return match.substr(0, 1) + '-' + match.substr(1, 1).toLowerCase();
    })
        .toLowerCase()
        .replace(/[^-a-z0-9]+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
};
export const attachCustomEvents = (node, props) => {
    // some test frameworks don't render DOM elements, so we test here to make sure we are dealing with DOM first
    if (node instanceof Element) {
        Object.keys(props).forEach((propName) => {
            if (propName.indexOf('on') === 0 && propName[2] === propName[2].toUpperCase()) {
                const eventName = propName.substring(2).toLowerCase();
                if (isCustomEvent(eventName)) {
                    const eventStore = node.__events || (node.__events = {});
                    const oldEventHandler = eventStore[eventName];
                    const newEventHandler = props[propName];
                    // Remove old listener
                    if (oldEventHandler) {
                        node.removeEventListener(eventName, oldEventHandler);
                    }
                    // Add new listener
                    node.addEventListener(eventName, (eventStore[eventName] = function handler(e) {
                        if (newEventHandler) {
                            newEventHandler.call(this, e);
                        }
                    }));
                }
            }
        });
    }
};
export const detachCustomEvents = (node) => {
    if (node instanceof Element) {
        const eventStore = node.__events || (node.__events = {});
        Object.keys(eventStore).forEach((eventName) => {
            const oldEventHandler = eventStore[eventName];
            node.removeEventListener(eventName, oldEventHandler);
        });
    }
};
/**
 * Checks if an event is supported in the current execution environment.
 */
export const isCustomEvent = (eventNameSuffix) => {
    const eventName = 'on' + eventNameSuffix;
    let isSupported = eventName in document;
    if (!isSupported) {
        const element = document.createElement('div');
        element.setAttribute(eventName, 'return;');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isSupported = typeof element[eventName] === 'function';
    }
    return !isSupported;
};
